import * as React from 'react';
import classnames from 'classnames';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import './reporting-component-header.scss';

type Props = {
  title: string,
  isCollapsed: boolean,
  toggleCollapsed: () => void
};

const ReportingComponentHeader = (
  {
    title,
    isCollapsed,
    toggleCollapsed
  }: Props
): JSX.Element => {
  const iconClasses = classnames('reporting-component-header__icon', {
    'reporting-component-header__icon--collapsed': isCollapsed
  });

  return (
    <div className="reporting-component-header">
      <div className={iconClasses}>
        <SVGDynamicIcon
          name="chevron-up-custom-fg"
          width={15}
          height={8}
          customColor="black"
          clickable
          onClick={() => toggleCollapsed()}
        />
      </div>
      <span
        onClick={() => toggleCollapsed()}
        className="reporting-component-header__title"
      >
        {title}
      </span>
    </div>
  );
};

export default ReportingComponentHeader;
